module.exports = __webpack_public_path__ + "assets/abb25eb19de25e5442bb84ab585a488e.mp4";